import { __decorate, __metadata } from "tslib";
import { raise } from "@leavy/utils";
import { cloneDeep } from "lodash-es";
import { injectable } from "inversify";
let TypedStorage = class TypedStorage {
    constructor(storage, key, defaultValue) {
        this.storage = storage;
        this.key = key ?? raise(new Error("key is required"));
        this.defaultValue = cloneDeep(defaultValue);
    }
    getDefaultWrappedValue() {
        return {
            date: undefined,
            value: cloneDeep(this.defaultValue),
        };
    }
    onSave(value) {
        return value;
    }
    onLoad(value) {
        return value;
    }
    load() {
        const storedJson = this.storage.getItem(this.key);
        if (storedJson === null) {
            return this.getDefaultWrappedValue();
        }
        else {
            const deserialized = JSON.parse(storedJson);
            const wrappedValue = {
                date: new Date(deserialized.date),
                value: this.onLoad(deserialized.value),
            };
            return wrappedValue;
        }
    }
    save(wrappedValue) {
        const toSerialize = {
            date: (wrappedValue.date ?? new Date()).toISOString(),
            value: this.onSave(wrappedValue.value),
        };
        this.storage.setItem(this.key, JSON.stringify(toSerialize));
    }
    getLastModificationDate() {
        return this.load().date;
    }
    getValue() {
        return this.load().value;
    }
    setValue(value) {
        this.save({
            date: new Date(),
            value: cloneDeep(value),
        });
    }
    resetValue() {
        this.storage.removeItem(this.key);
        return this.getDefaultWrappedValue();
    }
};
TypedStorage = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Storage, String, Object])
], TypedStorage);
export { TypedStorage };
//# sourceMappingURL=TypedStorage.js.map